import React, { useState } from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import ContentRow from '../components/ContentRow';
import ContentCard from '../components/ContentCard';
import { PageHeader, Chips, Grid, EmptyState } from '../components/PageBits';
import { useCatalog } from '../context/CatalogContext';
import { Tv } from 'lucide-react';

const FILTERS = ['All', 'Drama', 'Comedy', 'Thriller', 'Reality', 'Lifestyle', 'Documentary', 'Kids', 'Crime'];

export default function Shows() {
  const [genre, setGenre] = useState('All');
  const { shows } = useCatalog();
  const byGenre = (g) => shows.filter((m) => m.genres.includes(g));
  const filtered = genre === 'All' ? shows : byGenre(genre);
  const sections = [
    { title: 'Trending Series', items: [...shows].sort((a, b) => b.match - a.match) },
    { title: 'Clax Originals', items: shows.filter((s) => s.isOriginal) },
    { title: 'Drama', items: byGenre('Drama') },
    { title: 'Comedy', items: byGenre('Comedy') },
    { title: 'Reality', items: byGenre('Reality') },
    { title: 'Lifestyle', items: byGenre('Lifestyle') },
    { title: 'Documentaries', items: byGenre('Documentary') },
    { title: 'African Series', items: shows.filter((m) => /Twi|Pidgin|Swahili|Afrikaans|Yoruba/.test(m.language)) },
  ];
  return (
    <Layout>
      <PageHeader title="Shows" subtitle="Series, seasons and episodes worth bingeing." />
      <Chips options={FILTERS} value={genre} onChange={setGenre} className="px-[22px] mb-4" testId="show-genres" />
      {genre === 'All' ? (
        <>
          <div className="px-[22px]"><div className="rounded-xl overflow-hidden"><Hero compact slides={[{ contentId: 'fallen-ties' }, { contentId: 'city-of-lights' }, { contentId: 'the-heiress' }]} /></div></div>
          {sections.map((s) => <ContentRow key={s.title} title={s.title} items={s.items} testId={`shows-row-${s.title.toLowerCase().replace(/\s+/g, '-')}`} />)}
          <div className="h-10" />
        </>
      ) : (
        <div className="pb-10">
          <div className="px-[22px] mb-3 text-[13px] text-[#C7C4CB]">{filtered.length} {genre} series</div>
          {filtered.length ? <Grid>{filtered.map((m) => <ContentCard key={m.id} item={m} className="!w-full" />)}</Grid> : <EmptyState icon={Tv} title="No shows in this genre yet" />}
        </div>
      )}
    </Layout>
  );
}
